module.exports = __webpack_public_path__ + "static/media/megha.403c94b0.jpg";